import { SEARCH_RESULT_CONTAINER_ID } from '@/constants/index';
import { Grid } from '@nxt-costco-com/forge-components';
import { ProductTileSkeleton } from '@nxt-costco-com/forge-digital-components';

export function LoadingResultsGrid({
    singleItemGridSize,
}: {
    singleItemGridSize: number;
}) {
    return (
        <Grid
            container
            style={{ margin: 0 }}
            spacing={6}
            id={SEARCH_RESULT_CONTAINER_ID}
        >
            {[...Array(12).keys()].map((_, index) => {
                return (
                    <Grid
                        sx={{
                            display: 'flex',
                            justifyContent: 'center',
                        }}
                        key={`criteo_${index}_skeleton`}
                        size={{ xs: singleItemGridSize }}
                    >
                        <ProductTileSkeleton />
                    </Grid>
                );
            })}
        </Grid>
    );
}
